import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { saveLocalizationPreferences } from '../localePreference';
import { jobSeekerTranslations } from '../locales';

// Profile and Settings save the same UI and coaching language together.
export default function useLanguagePreference({ user, profile, onProfileSaved }) {
  const { language, changeLanguage } = useLanguage();
  const [localeBusy, setLocaleBusy] = useState('');
  const [localeFeedback, setLocaleFeedback] = useState('');
  const message = (locale, key) => jobSeekerTranslations[locale]?.settings?.language?.[key]
    || jobSeekerTranslations.en.settings.language[key];
  const handleLanguageChange = async (nextLanguage) => {
    if (nextLanguage === language || localeBusy) return;
    const previousLanguage = language;
    setLocaleBusy(nextLanguage);
    setLocaleFeedback('');
    changeLanguage(nextLanguage);
    try {
      if (onProfileSaved) {
        const localization = {
          uiLocale: nextLanguage, aiLocale: nextLanguage,
          artifactLocale: profile?.localization?.artifactLocale || 'auto',
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
          updatedAt: Date.now(),
        };
        await saveLocalizationPreferences(user, localization);
        await onProfileSaved(Object.fromEntries(Object.entries(localization).map(([key, value]) => [`localization/${key}`, value])));
      }
      setLocaleFeedback(message(nextLanguage, 'saved'));
    } catch {
      changeLanguage(previousLanguage);
      setLocaleFeedback(message(previousLanguage, 'failed'));
    } finally {
      setLocaleBusy('');
    }
  };
  return { localeBusy, localeFeedback, handleLanguageChange };
}
